import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { approveParticipant } from '../../../av-moderation/actions';
import Button from '../../../base/ui/components/web/Button';
import { QUICK_ACTION_BUTTON } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        button: {
            marginRight: theme.spacing(2)
        }
    };
});
const ParticipantQuickAction = ({ askUnmuteText, buttonType, muteAudio, muteParticipantButtonText, participantID, participantName }) => {
    const { classes: styles } = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const askToUnmute = useCallback(() => {
        dispatch(approveParticipant(participantID));
    }, [dispatch, participantID]);
    switch (buttonType) {
        case QUICK_ACTION_BUTTON.MUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.mute')} ${participantName}`, className: styles.button, label: muteParticipantButtonText, onClick: muteAudio(participantID), size: 'small', testId: `mute-${participantID}` }));
        }
        case QUICK_ACTION_BUTTON.ASK_TO_UNMUTE: {
            return (React.createElement(Button, { accessibilityLabel: `${t('participantsPane.actions.askUnmute')} ${participantName}`, className: styles.button, label: askUnmuteText, onClick: askToUnmute, size: 'small', testId: `unmute-${participantID}` }));
        }
        default: {
            return null;
        }
    }
};
export default ParticipantQuickAction;
